export default {
  gameLobby: "游戏大厅",
  account: "帐号",
  balance: "余额",
  searchGame: "搜寻游戏",
  gameSearch: "游戏搜索",
  myFollowedGames: "最爱游戏",
  allGames: "全部",
  like: "关注",
  new: "最新",
  hot: "热门",
  reco: "推荐",
  enterGame: "进入游戏",
  searchText: `关于 <0>{{searchValue}}</0> 的搜寻结果如下：`,
  goToHotGames: "前往热门",
  soEmpty: "哎呀~空荡荡的",
  cantFindGame: "找不到相符的游戏",
  noGameCanPlay: "哎呀～目前没有游戏可玩",
  cantFindPage: "未找到网页",
  sorryPageRunAway: "抱歉，此页面离家出走中",
  backToHome: "回首页",
  authFail: "认证失效",
  goWrong: "帐号认证已失效，请关闭页面",
  maintain: "维护中",
  annoucement: "公告",
  websiteMaintenance: "网站维护",
  systemMaintain: "系统维护升级中，请稍后访问。",
  recentPlayed: "近期玩过",
  send: "送出",
  payoutRank: "派彩指数",
  playerRank: "玩家排行",
  rank: "名次",
  recommend: "精选游戏",
  idRound: "玩家ID/局号",
  payout: `派彩金额 <span class="highlight">(¥)</span>`,
  payoutInfo: {
    title: "每小时更新",
    content: [
      `当派彩指数 > 0时，
  表示前一個小时派彩 <span class="highlight">高于</span> 理论值。`,
      `当派彩指数 < 0时，
  表示前一個小时派彩 <span class="highlight">低于</span> 理论值。`,
    ],
  },
  playerInfo: {
    title: "前30日排行",
    content: [`依照玩家的派彩金额由多至少的总排名。`],
  },
  newToOld: "新 → 旧",
  oldToNew: "旧 → 新",
  favorite: "最爱",
}
